export const SUPPORT_PHONE = "1 (888) 979-9580";
export const SUPPORT_PHONE_LINK = "tel:+18889799580";
